// 数字加千分号,也适合小数
import { Space, Tooltip } from 'antd';
import { isNaN as isNaNLodash } from 'lodash-es';
import numeral from 'numeral';
import React, { ReactNode } from 'react';

export function formatNum(num?: number | null): string {
  if (num && num !== -1) {
    const parts = num.toString().split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return parts.join('.');
  }
  return '0';
}

export function formatNaNArr(arr: (string | number)[]) {
  const d = arr || [];
  return d.map((num) => {
    if (isNaN(num)) return 0;

    return num;
  });
}

export function formatNaN(num?: string | number | null) {
  if (!num || isNaN(num)) return 0;

  return num;
}

/**
 * byte转MB
 * MB小于0.01还是用Byte展示
 * @param num
 * @param formatter
 * @param fontSize
 */
export function formatByte2Mb(num: number, formatter = '0.00', fontSize = 10): ReactNode {
  const value = formatByteAdaptive(num, formatter);

  return (
    <Tooltip title={`${numeral(num).format(formatter)} B`}>
      <Space size={2}>
        <span>{value.num}</span>
        <span style={{ fontSize }}>{value.unit}</span>
      </Space>
    </Tooltip>
  );
}

export function isNaN(value: string | number) {
  if (value === 'NAN' || value === 'NaN') return true;
  return isNaNLodash(value);
}

/**
 * 动态自适应展示, 比如1s 展示成1h
 * @param milliseconds
 *
 */
export function formatDateAdaptive(milliseconds: number, formatter = '0.00') {
  if (isNaN(milliseconds)) {
    return milliseconds;
  }
  if (milliseconds < 1000) {
    return `${numeral(milliseconds).format(formatter)}ms`;
  }
  const seconds = milliseconds / 1000;
  const days = 86400;
  const hours = 3600;
  const minutes = 60;

  const dd = Math.floor(seconds / days);
  const hh = Math.floor((seconds % days) / hours);
  const mm = Math.floor((seconds % hours) / minutes);
  const ss = seconds % minutes;

  if (dd > 0) {
    return `${dd}d ${hh}h ${mm}min ${Math.floor(ss)}s`;
  } if (hh > 0) {
    return `${hh}h ${mm}min ${Math.floor(ss)}s`;
  } if (mm > 0) {
    return `${mm}min ${Math.floor(ss)}s`;
  }

  return `${numeral(ss).format('0.00')}s`;
}

export function formatByteAdaptive(num: number, formatter = '0.00'): {
  num: string,
  unit: string
} {
  const value = {
    num: `${num || 0}`,
    unit: 'MB',
  };

  const mb = (Number(num) / 1024 / 1024);
  const kb = (Number(num) / 1024);
  const gb = (Number(num) / 1024 / 1024 / 1024);
  const tb = (Number(num) / 1024 / 1024 / 1024 / 1024);

  if (kb < 0.01) {
    value.num = numeral(num).format(formatter);
    value.unit = 'B';
    return value;
  } if (kb >= 0.01 && mb < 1) {
    value.num = numeral(kb).format(formatter);
    value.unit = 'KB';
    return value;
  } if (mb >= 0.01 && gb < 1) {
    value.num = numeral(mb).format(formatter);
    value.unit = 'MB';
    return value;
  } if (gb >= 0.01 && tb < 1) {
    value.num = numeral(gb).format(formatter);
    value.unit = 'GB';
    return value;
  }

  value.num = numeral(tb).format(formatter);
  value.unit = 'TB';
  return value;
}

export function formatByte2MbStr(num: number, formatter = '0.00'): ReactNode {
  const value = formatByteAdaptive(num, formatter);

  return `${value.num} ${value.unit}`;
}

export function formatByteSmallMb(num: number): ReactNode {
  const value = formatByteAdaptive(num);

  return (
    <Tooltip title={`${numeral(num).format('0.00')} B`}>
      <Space size={0}>
        <span>{value.num}</span>
        <span style={{ transform: 'scale(0.8)', fontSize: 14,
          display: 'inline-block',
          verticalAlign: 'middle' }}>{value.unit}</span>
      </Space>
    </Tooltip>
  );
}
